// extracted by mini-css-extract-plugin
module.exports = {"sfdcModal":"salesforce-modal_sfdcModal_xUH"};